import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { UserNotification } from './user-notification';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from '../../data/abstract-ui-entity.store';

export interface NotificationsState extends EntityState<UserNotification, number> {
	ui: {
		totalUnread: number,
		total: number
	};
}

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'notifications' })
export class NotificationsStore extends AbstractUiEntityStore<NotificationsState> {
	constructor() {
		super({
			ui: {
				totalUnread: 0,
				total: 0
			}
		})
	}

	decreaseTotalUnread(): void {
		this.updateUi({
			totalUnread: this._value().ui.totalUnread - 1
		})
	}

	updateTotalUnread(totalUnread: number) {
		this.updateUi({
			totalUnread
		})
	}

	updateTotal(total: number) {
		this.updateUi({
			total
		})
	}
}